module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 61
// module chunks = 8508348135794 213534597649335 220753811298009